export default "__VITE_ASSET__B8PE9qB7__"